<template>
    <div 
        class="componentWrapper" 
        :class="{ extraPadding: currentRouteName === 'catalogPage' || currentRouteName === 'listingPage' }"
    >
        <div class="body">
            <div class="section" id=" .logoSmall" style="width: 25%">
                <img
                    class="logoSmall"
                    :src="require('../../../assets/vegotarLong.png')" 
                    alt=""
                >
                <p>{{ $t('footer.text', currentLang) }}</p>
            </div>
            <div class="section" style="width: 13%">
            </div>
            <div class="section" style="width: 22%">
                <h3><i class="pi pi-map-marker"></i> {{ $t('footer.office', currentLang) }}</h3>
                <p>{{ $t('company.address', currentLang) }}</p>
                <p>{{ $t('company.email', currentLang) }}</p>
                <p>{{ $t('company.number', currentLang) }}</p>
                <p>{{ $t('company.representitive', currentLang) }}</p>
            </div>
            <div class="section">
                <h3><i class="pi pi-briefcase"></i> {{ $t('footer.business', currentLang) }}</h3>
                <p>{{ $t('company.name', currentLang) }}</p>
                <p>Reg. {{ $t('company.regNr', currentLang) }}</p>
                <p>KMKR. {{ $t('company.kmkr', currentLang) }}</p>
                <p>{{ $t('company.bank', currentLang) }}</p>
            </div>
            <div class="section" id="navSection" style="text-align: end">
                <h3 style="margin-left: auto;"><i class="pi pi-compass"></i> {{ $t('footer.navigation', currentLang) }}</h3>
                <p @click="$router.push({name: 'shopLanding'})">{{ $t('footer.navigations.home', currentLang) }}</p>
                <!-- <p @click="$router.push({name: 'referencesPage'})">{{ $t('footer.navigations.works', currentLang) }}</p> -->
                <p @click="$router.push({name: 'catalogPage'})">{{ $t('footer.navigations.shop', currentLang) }}</p>
                <p @click="$emit('openCartSidebar')">{{ $t('footer.navigations.cart', currentLang) }}</p>
            </div>
            <languageSwitcher class="switcher"/>
        </div>
        <div class="foot">
            <div class="footBtns">
                <a @click="$router.push({name: 'termsPage'})">{{ $t('footer.navigations.privacy', currentLang) }}</a>
                <a @click="$router.push({name: 'termsPage'})">{{ $t('footer.navigations.terms', currentLang) }}</a>
            </div>
            <p>{{ $t('company.name', currentLang) }} © {{new Date().getFullYear()}} - {{ $t('footer.reserved', currentLang) }}</p>
        </div>
    </div>
</template>
  
<script>
import languageSwitcher from '../../languageSwitcher.vue';

export default {
    name: 'footerMain',
    components: {
        languageSwitcher
    },
    props: {
        currentRouteName: String
    },
    data() {
        return {
            
        };
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'et'; // Default to 'et' if no lang param
        }
    },
    methods: {
        
    },
    created() {
        

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>

<style scoped>
.componentWrapper {
    overflow: hidden;
    position: relative;
    padding-top: 50px;
    padding-bottom: 25px;
    background: white;
    border-top: 1px solid rgb(240,240,240);
}

.componentWrapper.extraPadding {
    padding-left: 135px;
    margin-top: 100px;
}

.body {
    position: relative;
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #7888a13f;
    padding-bottom: 15px;
}

.logoSmall {
    background: rgba(255, 255, 255, 0.99);
    margin-bottom: 10px;
}

.section {
    width: 20%;
    color: #354052;
}

.section h3 {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 20px;
    padding-bottom: 5px;
    margin-top: 0;
    color: rgb(75,75,75);
}

.section p {
    font-family: "Inter", sans-serif;
    font-weight: 400;
    opacity: .8;
    color: #3a5a75;
}

.section a {
    padding-bottom: 5px;
}
.section i {
    margin-right: 2px;
}
#navSection p:hover {
    cursor: pointer;
    text-decoration: underline
}

.foot {
    width: 1300px;
    margin: 0 auto;
    color: #354052;
    color: #3a5a75;
    
    display: flex;
    padding-top: 10px;
}

.foot p {
    margin: 0;
    margin-left: auto;
    text-align: end;
    opacity: .8;
}

.foot a {
    margin-right: 15px;
    color: rgb(100,100,100);
    color: #3a5a75;
}
.foot a:hover {
    text-decoration: underline;
    cursor: pointer;
}
.switcher {
    position: absolute;
    right: 0;
    bottom: 10px;
}
@media (max-width: 450px ){
    .componentWrapper {
        padding-left: 25px;
    }
}
</style>